import { Link } from 'react-router-dom';
import { useAppStore } from '@store/useAppStore';
import iconImage from '../../assets/images/icon.png';

// --- INLINE SVG ICONS ---
// Harici paket (lucide-react veya react-icons) gerektirmeyen, doğrudan gömülü ikonlar.
// Bu sayede "module not found" hataları yaşanmaz.
const Icons = {
  Menu: ({ size = 24, className = "" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <line x1="4" y1="12" x2="20" y2="12"></line>
      <line x1="4" y1="6" x2="20" y2="6"></line>
      <line x1="4" y1="18" x2="20" y2="18"></line>
    </svg>
  ),
  X: ({ size = 24, className = "" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  ),
  Moon: ({ size = 24, className = "" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
    </svg>
  ),
  Sun: ({ size = 24, className = "" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="12" cy="12" r="5"></circle>
      <line x1="12" y1="1" x2="12" y2="3"></line>
      <line x1="12" y1="21" x2="12" y2="23"></line>
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
      <line x1="1" y1="12" x2="3" y2="12"></line>
      <line x1="21" y1="12" x2="23" y2="12"></line>
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
    </svg>
  ),
  Rocket: ({ size = 24, className = "" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
    </svg>
  )
};

export const Header = () => {
  const { theme, sidebarOpen, toggleTheme, toggleSidebar } = useAppStore();

  return (
    <header
      className="sticky top-0 z-40 transition-all duration-300 border-b border-orange-100/50"
      style={{
        // Resim yerine "Mucit" konseptine uygun, kağıt dokulu hissi veren sıcak bir gradient
        background: 'linear-gradient(120deg, #fdfbf7 0%, #fff4e6 100%)',
      }}
    >
      {/* Glassmorphism Overlay: Arka planın üzerine buzlu cam etkisi */}
      <div className="absolute inset-0 bg-white/60 backdrop-blur-md supports-[backdrop-filter]:bg-white/50" />

      <div className="relative container mx-auto px-4">
        <div className="flex items-center justify-between h-20"> {/* Yükseklik h-20 (Ferahlık) */}

          {/* --- SOL TARAFI: HAMBURGER & LOGO --- */}
          <div className="flex items-center gap-4">
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-full hover:bg-orange-100 text-gray-600 hover:text-orange-600 transition-all duration-300 md:hidden"
              aria-label="Toggle sidebar"
            >
              {sidebarOpen ? <Icons.X size={22} /> : <Icons.Menu size={22} />}
            </button>

            <Link to="/" className="group flex items-center gap-3">
              {/* Logo İkonu: icon.png resmi */}
              <div className="w-12 h-12 bg-gradient-to-br from-orange-50 to-pink-50 rounded-2xl p-1.5 flex items-center justify-center transform group-hover:rotate-12 group-hover:scale-110 transition-all duration-300 shadow-md shadow-orange-100">
                <img
                  src={iconImage}
                  alt="Mucittin Logo"
                  className="w-full h-full object-contain rounded-xl"
                />
              </div>
              {/* Logo Yazısı */}
              <span className="text-2xl font-black tracking-tight text-gray-800 group-hover:text-orange-600 transition-colors">
                Mucittin
              </span>
            </Link>
          </div>

          {/* --- ORTA: NAVİGASYON (Startup/App Tarzı) --- */}
          <nav className="hidden md:flex items-center gap-2 bg-white/80 p-1.5 rounded-full border border-gray-100 shadow-sm backdrop-blur-sm">
            {[
              { path: '/', label: '🏠 Ana Sayfa' },
              { path: '/about', label: '❤️ Mucittin Kimdir?' },
              { path: '/services', label: '🎮 Aktiviteler' },
              { path: '/contact', label: '✉️ Mesaj Gönder' }
            ].map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="px-5 py-2 rounded-full text-sm font-bold text-gray-600 hover:text-orange-600 hover:bg-white hover:shadow-md transition-all duration-300"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* --- SAĞ TARAF: AKSİYONLAR --- */}
          <div className="flex items-center gap-3">
            {/* Tema Butonu */}
            <button
              onClick={toggleTheme}
              className="p-2.5 rounded-full bg-white border border-gray-200 text-gray-500 hover:text-orange-500 hover:border-orange-200 hover:shadow-md transition-all duration-300"
              aria-label="Toggle theme"
            >
              {theme === 'light' ? <Icons.Moon size={18} /> : <Icons.Sun size={18} />}
            </button>

            {/* "Hadi Başla" Butonu (Ekstra CTA - Startup Havası İçin) */}
            <button className="hidden lg:flex items-center gap-2 bg-gray-900 hover:bg-orange-500 text-white px-5 py-2.5 rounded-full font-bold text-sm transition-colors duration-300 shadow-lg shadow-gray-200">
              <Icons.Rocket size={16} />
              <span>Keşfet</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};